import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';

const AuditLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/audit-logs')
      .then(r => setLogs(r.data.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 32, color: 'var(--text-muted)' }}>Loading...</div>;

  return (
    <div className="page-content">
      <div className="flex-between mb-24">
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Audit Log</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>{logs.length} recent events</p>
        </div>
      </div>
      {!logs.length ? (
        <div className="empty-state"><ShieldCheck /><p>No audit events yet</p></div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Time</th><th>Actor</th><th>Action</th><th>Entity</th><th>Details</th></tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    <td style={{ whiteSpace: 'nowrap', color: 'var(--text-muted)' }}>{new Date(log.createdAt).toLocaleString()}</td>
                    <td>
                      <div style={{ fontWeight: 500 }}>{log.actorName || 'System'}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{log.actorRole || '-'}</div>
                    </td>
                    <td><span className="badge badge-blue">{log.action}</span></td>
                    <td>
                      <div style={{ fontWeight: 500 }}>{log.entityName || log.entityId || '-'}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{log.entityType}</div>
                    </td>
                    <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{Object.keys(log.details || {}).length ? JSON.stringify(log.details) : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditLog;
